import type { CSSProperties } from 'react';

/**
 * V2 設計系統共用基礎元件
 * -----------------------------------------------------------------------------
 * R164 大改版:TopNav(logo + GroupSwitcher + 用量 chip + Bell + ThemeMenu)整列
 * 退場 — 機能移入 AppSidebar(側邊欄制,見 AppShell)。用量 chip 隨「前端不顯示
 * 點數」拍板刪除;`Icons` 集只剩 TopNav 在用,一併移除。
 * 本檔只剩 LoginPage 用的 DolphinMark 吉祥物。
 */

interface DolphinMarkProps {
  size?: number;
  color?: string;
  style?: CSSProperties;
  ariaHidden?: boolean;
}

/** Cute 變體海豚 — 大頭、大眼、紅頰；專案吉祥物。 */
export function DolphinMark({
  size = 28,
  color = 'currentColor',
  style,
  ariaHidden = true,
}: DolphinMarkProps) {
  return (
    <svg
      width={size}
      height={size * 0.72}
      viewBox="0 0 128 92"
      fill="none"
      style={style}
      aria-hidden={ariaHidden}
    >
      <path
        fill={color}
        d="M 6 50 Q 6 36 18 28 Q 32 18 52 18 Q 74 18 90 28 Q 104 36 112 50 Q 118 60 120 72 Q 116 72 110 68 Q 102 60 92 56 Q 80 54 66 56 Q 50 60 38 62 Q 24 64 14 60 Q 6 56 6 50 Z"
      />
      <path fill={color} d="M 64 18 Q 68 6 78 8 Q 82 12 78 18 Q 72 20 64 18 Z" />
      <path
        fill={color}
        opacity="0.85"
        d="M 42 50 Q 34 64 26 64 Q 24 58 30 52 Q 36 48 42 48 Z"
      />
      <path
        fill={color}
        d="M 116 66 Q 128 56 128 64 Q 124 68 120 70 Q 128 74 124 82 Q 116 82 112 74 Q 112 70 116 66 Z"
      />
      <circle cx="26" cy="44" r="5.2" fill="var(--on-accent)" />
      <circle cx="27" cy="45" r="3.4" fill="var(--on-accent)" />
      <circle cx="28.5" cy="43.5" r="1.3" fill="var(--on-accent)" />
      <path
        stroke="var(--on-accent)"
        strokeWidth="1.4"
        strokeLinecap="round"
        fill="none"
        d="M 8 54 Q 12 56 16 54"
      />
      <ellipse cx="20" cy="54" rx="4" ry="1.8" fill="oklch(0.76 0.14 38)" opacity="0.55" />
    </svg>
  );
}
